import type { IWallet, IWalletWithTokens } from '../IWallet';
import {
  MOCK_SAVED_PAYMENT,
  MOCK_SAVED_PAYMENT_WITH_TOKEN
} from './MOCK_SAVED_PAYMENT';

export const MOCK_WALLET_WITH_TOKENS = {
  '9cb1b211-7a91-4d49-9c30-b346590b10e7': {
    ...MOCK_SAVED_PAYMENT_WITH_TOKEN,
    uuid: undefined
  }
} as IWalletWithTokens;

export const MOCK_WALLET = {
  '9cb1b211-7a91-4d49-9c30-b346590b10e7': {
    ...MOCK_SAVED_PAYMENT,
    uuid: undefined
  }
} as IWallet;
